import { Component, computed, inject } from '@angular/core';
import { NavButtonComponent } from './components/nav-button/nav-button.component';
import { TranslateModule } from '@ngx-translate/core';
import { MENU_NAV_ITEMS } from './config/constants';
import { PlannerViewsStateService } from '../planner/services/planner-views-state.service';
import { CUSTOM_ROUTE_MOBILE_MAP } from '../../components/custom-route-mobile/config/constants';
import { CustomRouteMobileViewsStateService } from '../../components/custom-route-mobile/services/custom-route-mobile-views-state.service';
import { SessionStorageService } from 'src/app/services/session-storage.service';

@Component({
  selector: 'app-menu-nav',
  standalone: true,
  imports: [
    NavButtonComponent, 
    TranslateModule
  ],
  templateUrl: './menu-nav.component.html',
  styleUrls: ['./menu-nav.component.scss'],
})
export class MenuNavComponent {
  private _plannerViewsStateService = inject(PlannerViewsStateService);
  private _sessionStorageService = inject(SessionStorageService);
  private _customRouteMobileViewsStateService = inject(CustomRouteMobileViewsStateService);
  
  private readonly _mobileViewsState = computed(() => this._customRouteMobileViewsStateService.mobileViewsState());
  
  public  navItems = MENU_NAV_ITEMS;

  public handleNavItemClick(view: string) {
    switch (view) {
      case CUSTOM_ROUTE_MOBILE_MAP.planner:
        this._sessionStorageService.setItem('customRouteMobileViewsState', CUSTOM_ROUTE_MOBILE_MAP.planner);
        this._customRouteMobileViewsStateService.setMobileViewsState(CUSTOM_ROUTE_MOBILE_MAP.planner);
        break;
      case CUSTOM_ROUTE_MOBILE_MAP.map:
        this._sessionStorageService.setItem('customRouteMobileViewsState', CUSTOM_ROUTE_MOBILE_MAP.map);
        this._customRouteMobileViewsStateService.setMobileViewsState(CUSTOM_ROUTE_MOBILE_MAP.map);
        break;
      case CUSTOM_ROUTE_MOBILE_MAP.chatbot:
        this._sessionStorageService.setItem('customRouteMobileViewsState', CUSTOM_ROUTE_MOBILE_MAP.chatbot);
        this._customRouteMobileViewsStateService.setMobileViewsState(CUSTOM_ROUTE_MOBILE_MAP.chatbot);
        break;
      case CUSTOM_ROUTE_MOBILE_MAP.more:
        this._sessionStorageService.setItem('customRouteMobileViewsState', CUSTOM_ROUTE_MOBILE_MAP.more);
        this._customRouteMobileViewsStateService.mobileViewsState.set(CUSTOM_ROUTE_MOBILE_MAP.more);
        break;
      default:
        this._sessionStorageService.setItem('customRouteMobileViewsState', CUSTOM_ROUTE_MOBILE_MAP.planner);
        this._customRouteMobileViewsStateService.setMobileViewsState(CUSTOM_ROUTE_MOBILE_MAP.planner);
        break;
    }
    
    // Close the edit route view if it's open
    // The default view of the planner is the route-timeline view
    this._plannerViewsStateService.isEditRouteView.set(false);
    this._plannerViewsStateService.isBuyTicketsView.set(false);
  }
  
  get mobileViewsState() {
    return this._mobileViewsState();
  }
}
